/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {$Container, FC} from '@gongxigames/framework/core/fragments/BuilderY';
import {SpecialInfoContainerProps} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/types';
import {ResponsiveConf, ResponsiveRectangleOptions} from '@gongxigames/framework/core/fragments/display/responsive';
import {Store} from '@gongxigames/framework/core';

// TODO: 1 looks like a component sold be in components
// 2 why service provides components?!...
export const $SpecialInfoZoneContainer: FC<SpecialInfoContainerProps> = (props) => {
    const getBox: () => ResponsiveRectangleOptions = () => {
        switch (props.stickTo) {
            case 'bottom':
                return {x: '0%', y: '100%', width: '100%'};
            case 'top':
                return {x: '0%', y: '0%', width: '100%'};
            case 'top-right':
                return {x: '0%', y: '0%'};
            case 'top-left':
                return {x: '0%', y: '0%'};
            default:
                return {x: '0%', y: '0%', width: '100%'};
        }
    };

    const responsive = Store.computed(() => {
        return {
            box: getBox(),
            translate: {x: `${props.xTranslate.value}px`, y: `${props.yTranslate.value}px`}
        } as ResponsiveConf;
    });

    return <$Container name={`${props.id + '_' + props.orientation}`} responsive={responsive}/>;
};